import {Autocomplete, FormControl, FormControlLabel, Radio, RadioGroup, TextField} from "@mui/material";
import cn from "classnames";
import GoogleMapReact from "google-map-react";
import i18n from "i18next";
import _ from "lodash"
import React, {useCallback, useEffect, useState} from "react";
import DatePicker from "react-datepicker";
import {Controller, useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {NotificationManager} from "react-notifications";
import {useAuth} from "react-oidc-context";
import {useDispatch, useSelector} from "react-redux";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import {getAllGasStationAdmins} from "../../actions/admin";
import {getAllClients} from "../../actions/client";
import {
  clearGasStationForEdit,
  editGasStation,
  geocodeAddressFetchFirstResult,
  geocodeAddressSetMarker
} from "../../actions/gasStation";
import {getAllGasStationManagers, getManagersByAdminId,} from "../../actions/manager";
import {getAllOwners, getAllOwnersForPZAdmin} from "../../actions/owners";
import {getAllViewers, getViewersByAdminId} from "../../actions/viewer";
import AddressesComponent, {formatAddress} from "../../common/address/AddressesComponent";
import XIcon from "../../common/assets/x-icon.svg";
import Button from "../../common/button/button";
import {getClientLogo, isAralDeClientId} from "../../common/client/clientHelper";
import AutoCompleteWithTags from "../../common/input/AutoCompleteWithTags";
import InputController from "../../common/input/inputController";
import InputFieldWithLabel from "../../common/input/inputFieldWithLabel";
import LabelWithHR from "../../common/labels/labelWithHR";
import {
  ADDRESS_GEOCODING_DELAY,
  aralFuelTypes,
  DebtNoteType,
  defaultMarker,
  manualParkingZoneMarkerEnabled,
  ROLES
} from "../../consts";
import ModalLoadingIndicator from "../../reusable/modalLoadingIndicator";
import {newModalStyle} from "../../reusable/styles";
import {currencyCode, formatCurrencyCode} from "../../utils/formatter";
import {mapUser} from "../../utils/mapUser";
import Marker, {colorMapOptions, dimmedMapOptions} from "../parkingZone/marker";
import Style from "./editGasStationModal.module.css";
import PricingStructureTable from "./PricingStructureTable";

const aralFuelTypesTransformed = Object.values(aralFuelTypes);

const EditGasStationModal = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const auth = useAuth();

  const loggedUser = mapUser(auth);

  const { admins } = useSelector((state) => state.admin);
  const { clients } = useSelector((state) => state.client);
  const beppolicemans = useSelector((state) => state.owners.owners);
  const { gasStationForUpdate } = useSelector((state) => state.gasStation);
  const { isLoading } = useSelector((state) => state.loader);
  const {handleSubmit, register, watch, control, setValue, getValues,  formState: { errors }}
        = useForm({
      mode: "onBlur",
      shouldUnregister: true,
      defaultValues: {
        serviceFee: gasStationForUpdate?.serviceFee,
        holderDataRetrieval: gasStationForUpdate?.holderDataRetrieval,
        invoicePaymentPeriod: gasStationForUpdate?.invoicePaymentPeriod,
        reminderPaymentPeriod: gasStationForUpdate?.reminderPaymentPeriod,
        lastReminderPaymentPeriod: gasStationForUpdate?.lastReminderPaymentPeriod,
        rvgMultiplierInvoice: gasStationForUpdate?.rvgMultiplierInvoice,
        rvgMultiplierReminder: gasStationForUpdate?.rvgMultiplierReminder,
        rvgMultiplierLastReminder: gasStationForUpdate?.rvgMultiplierLastReminder,
        baseFee: gasStationForUpdate?.baseFee,
        capBelow50: gasStationForUpdate?.capBelow50,
      }
    });

  const [counter, setCounter] = useState(0);
  const [viewerCounter, setViewerCounter] = useState(0);

  const { managers } = useSelector((state) => state.manager);
  const { viewers } = useSelector((state) => state.viewer);
  const [managersIds, setManagersIds] = useState([]);
  const [viewersIds, setViewersIds] = useState([]);
  const [managersComboBoxNames, setManagersComboBoxNames] = useState([]);
  const [viewersComboBoxNames, setViewersComboBoxNames] = useState([]);

  const [beppolicemansIds, setBeppolicemansIds] = useState([]);
  const [deletedBeppolicemansIds, setDeletedBeppolicemansIds] = useState([]);
  const [beppolicemansComboBoxNames, setBeppolicemansComboBoxNames] = useState([]);

  const [useClientDocs, setUseClientDocs] = useState(!!gasStationForUpdate?.useClientDocs);
  const countryWatch = watch("country", "0");
  const [geocoder, setGeocoder] = useState(null);
  const [map, setMap] = useState();
  const [initialRecenterAlreadyDone, setInitialRecenterAlreadyDone] = useState(false);
  const [newAddress, setNewAddress] = useState();

  const isSelectedCountryDE = () => countryWatch === "DE";
  const isSelectedCountryCH = () => countryWatch === "CH";  
  const isSelectedCountryAT = () => countryWatch === "AT";  

  const serviceFee = watch("serviceFee");
  const holderDataRetrieval = watch("holderDataRetrieval");
  const invoicePaymentPeriod = watch("invoicePaymentPeriod");
  const reminderPaymentPeriod = watch("reminderPaymentPeriod");
  const lastReminderPaymentPeriod = watch("lastReminderPaymentPeriod");
  const rvgMultiplierInvoice = watch("rvgMultiplierInvoice");
  const rvgMultiplierReminder = watch("rvgMultiplierReminder");
  const rvgMultiplierLastReminder = watch("rvgMultiplierLastReminder");
  const baseFee = watch("baseFee");
  const capBelow50 = watch("capBelow50");
  const [pricingStructure, setPricingStructure] = useState(
    gasStationForUpdate?.pricingStructure || null
  );
  const updatePricingValue = (fuelTypeIndex, field, value) => {
    const updatedStructure = { ...pricingStructure };
    updatedStructure.fuelTypes[fuelTypeIndex] = {
      ...updatedStructure.fuelTypes[fuelTypeIndex],
      [field]: parseFloat(value) || 0
    };
    setPricingStructure(updatedStructure);
  };
  useEffect(() => {
    setPowerOfAttorneyName(
      gasStationForUpdate.powerOfAttorneyName ? gasStationForUpdate.powerOfAttorneyName : ""
    );
    setDocumentationName(
      gasStationForUpdate.documentationName ? gasStationForUpdate.documentationName : ""
    );
  }, [gasStationForUpdate]);

  const [modifyGasStation, setModifyGasStation] = useState({
    number: gasStationForUpdate?.number,
    externalReferenceId: gasStationForUpdate?.externalReferenceId,
    name: gasStationForUpdate?.name,
    customer: gasStationForUpdate?.customer,
    address: gasStationForUpdate?.address,
    adminKeycloakId: gasStationForUpdate?.adminKeycloakId,
    internationalFee: gasStationForUpdate?.internationalFee,
    waitingPeriod: gasStationForUpdate?.waitingPeriod,
    clientName: gasStationForUpdate?.clientName,
    clientNumber: gasStationForUpdate?.clientNumber,
    profitCenter: gasStationForUpdate?.profitCenter,
    costCenter: gasStationForUpdate?.costCenter,
    payee: gasStationForUpdate?.payee,
    bic: gasStationForUpdate?.bic,
    iban: gasStationForUpdate?.iban,
    financialInstitution: gasStationForUpdate?.financialInstitution,
    contractDate: gasStationForUpdate?.contractDate?new Date(gasStationForUpdate.contractDate):null,
    salesArea: gasStationForUpdate?.salesArea,
    others: gasStationForUpdate?.others,
    representedBy: gasStationForUpdate?.representedBy,
    relationToProperty: gasStationForUpdate?.relationToProperty,
    notedBy: gasStationForUpdate?.notedBy,
    injuredPerson: gasStationForUpdate?.injuredPerson,
    additionalInfo: gasStationForUpdate?.additionalInfo,
    client: gasStationForUpdate?.client,
    clientId: gasStationForUpdate?.client?.id,
    useClientDocs: gasStationForUpdate?.useClientDocs,
    interruptAutoBilling: gasStationForUpdate?.interruptAutoBilling,
    hdStatusAutomation: gasStationForUpdate?.hdStatusAutomation,
    debtNoteType: gasStationForUpdate?.debtNoteType || DebtNoteType.GAS_STATION,
    marker : {
        center: {
            lat: gasStationForUpdate?.marker?.latitude || defaultMarker.center.lat,
            lng: gasStationForUpdate?.marker?.longitude || defaultMarker.center.lng
        }
    },
  });

  const [powerOfAttorneyName, setPowerOfAttorneyName] = useState("");
  const [powerOfAttorney, setPowerOfAttorney] = useState(null);
  const [documentation, setDocumentation] = useState(null);
  const [documentationName, setDocumentationName] = useState("");
  const categoryPaymentDetails = gasStationForUpdate?.categoryPaymentDetails;
  const [selectedLabels, setSelectedLabels] = useState(gasStationForUpdate.existingLabels || []);

  const [fuelTypesSelected, setFuelTypesSelected] = useState(
      aralFuelTypesTransformed.reduce((acc, element) => ({
        ...acc,
        [element]: gasStationForUpdate.aralFuelTypes?.split(",").includes(element)
      }), {})
  );
  const resetSelectedFuelTypes = () => {
    setFuelTypesSelected(
      aralFuelTypesTransformed.reduce((acc, name) => {
        acc[name] = false;
        return acc;
      }, {})
    );
  };

  const handleFuelTypesChange = (name, value) => {
    setFuelTypesSelected((prevStates) => {
      const newState = { ...prevStates, [name]: value };
      return newState;
    });
  };

  useEffect(() => {
    if (!gasStationForUpdate?.managersIds) {
      setManagersIds([]);
      setManagersComboBoxNames([]);
      setCounter(0);
    } else {
      setManagersIds(gasStationForUpdate?.managersIds);
      const array = gasStationForUpdate?.managersIds.map(
        (m, index) => index + 1
      );
      setManagersComboBoxNames(array);
      setCounter(gasStationForUpdate?.managersIds.length);
    }
    if (!gasStationForUpdate?.viewersIds) {
      setViewersIds([]);
      setViewersComboBoxNames([]);
      setViewerCounter(0);
    } else {
      setViewersIds(gasStationForUpdate?.viewersIds);
      const array = gasStationForUpdate?.viewersIds.map(
          (m, index) => index + 1
      );
      setViewersComboBoxNames(array);
      setViewerCounter(gasStationForUpdate?.viewersIds.length);
    }

    console.log("beppolicemen", gasStationForUpdate?.beppolicemansIds)

    if (!gasStationForUpdate?.beppolicemansIds) {
      setBeppolicemansIds([]);
      setBeppolicemansComboBoxNames([]);
    } else {
      setBeppolicemansIds(gasStationForUpdate?.beppolicemansIds);
      const array = gasStationForUpdate?.beppolicemansIds.map(
          (b, index) => index + 1
      );
      setBeppolicemansComboBoxNames(array);
    }
  }, [gasStationForUpdate]);

  const documentUpload = (e, files, setFiles, filesNames, setFilesNames, isSingleFile) => {
    if (e.target.files.length !== 0) {
     let fileList = files === null ? [] : files;
             let names = filesNames;
             for (let i = 0; i < e.target.files.length; i++) {
               if (isSingleFile && i === 0) {
                 fileList = [];
                 fileList.push(e.target.files[i])
                 names = e.target.files[i].name;
               } else {
                 fileList.push(e.target.files[i]);
                 names = names === "" ? e.target.files[i].name : names.concat("|", e.target.files[i].name);
               }
             }
             setFiles(fileList);
             setFilesNames(names);
           }
  };

  const onAddressAdded = (newAddress) => {
      setModifyGasStation({
        ...modifyGasStation,
        address: newAddress,
      });
      setNewAddress(newAddress);
    };

  useEffect(() => {
      if (newAddress && map && geocoder) {
        // map is loaded, geocoder is loaded
        // address is valid, begin geocoding sometimes in the future
        memoizedDebouncedGeocoding(map, geocoder, newAddress, setMarker);
      }
    }, [newAddress]);

  function setMarker(marker) {
          setModifyGasStation({
            ...modifyGasStation,
//            marker: {marker}
            marker : {
                center: {
                    lat: marker?.center.lat,
                    lng: marker?.center.lng
                }
            },
          });
        }

      const fixupMarkers = async () => {
        if (map && geocoder && modifyGasStation?.address && modifyGasStation?.marker) {
          // everything is loaded, we have a correct address, but no markers
          // attempting to automatically and silently set markers
          console.info("Fixup markers");
          await geocodeAddressSetMarker(map, geocoder, modifyGasStation.address, setMarker, false);
        }
       };

        const recenterMap = async () => {
          if (!initialRecenterAlreadyDone && modifyGasStation?.address && modifyGasStation?.marker) {

            // if we have some marker, we try to position it a bit nicer

            const marker = modifyGasStation.marker
            const address = modifyGasStation.address;
            const formattedAddress = formatAddress(address);
            const {firstResult, firstGeometry} = await geocodeAddressFetchFirstResult(geocoder, address.countryCode, formattedAddress);

            if (firstGeometry.viewport.contains(marker.center)) {

              if (firstResult.types.includes("street_address")) {
                // when result is a street address, zoom to viewport
                map.fitBounds(firstGeometry.viewport);
                map.setZoom(map.getZoom() + 2) // inch a bit closer
              } else {
                // when result is not a street address, center on marker
                map.setCenter(marker.center)
              }
            }
          }
          setInitialRecenterAlreadyDone(true);
        };

        const onTilesLoaded = () => {
          fixupMarkers().
          then(recenterMap());
        };

        const memoizedDebouncedGeocoding = useCallback(
         _.debounce((map, geocoder, address, setMarkersCallback) => {

           const formattedAddress = formatAddress(address);
           NotificationManager.info(
               t('EditParkingZoneModal.geocodingAddressLong', {formattedAddress: formattedAddress}),
               t('EditParkingZoneModal.geocodingAddress'),
               1500
           );
           geocodeAddressSetMarker(map, geocoder, address, setMarkersCallback)
               .then(_ => {
                 // loader...
               })
               .finally({
                 // loader

               })
         },
         ADDRESS_GEOCODING_DELAY), []);


  const removeDocument = (
    files,
    setFiles,
    filesNames,
    setFilesNames,
    elementForRemoveName
  ) => {
    files !== null &&
      setFiles([...files?.filter((f) => f.name !== elementForRemoveName)]);
    const namesArray = filesNames
      ?.split("|")
      .filter((fn) => fn !== elementForRemoveName);
    setFilesNames(namesArray?.join("|"));
  };

  const showDocumentsNames = (files, setFiles, filesNames, setFilesNames) => {
    return filesNames?.split("|")?.map((n, index) => (
      <div key={index} className={Style.documentRow}>
        <div className={Style.uploadedFileName}>{n}</div>
        <div className={Style.documentLine} />
        <div className={Style.removeDocument}>
          <img
            alt=""
            src={XIcon}
            height="25px"
            width="25px"
            onClick={() => {
              removeDocument(files, setFiles, filesNames, setFilesNames, n);
            }}
          />
        </div>
      </div>
    ));
  };

  const isLoggedUserSysadmin = loggedUser?.roles?.includes(ROLES.SYSADMIN);

  // backend replaces the station's power of attorney with the client's while useClientDocs is enabled
  const selectedClient = clients.find(c => c.id === modifyGasStation?.clientId);
  const showPoaIgnoredWarning = useClientDocs && !!modifyGasStation?.clientId && powerOfAttorney?.length > 0;

  useEffect(() => {
    if (isLoggedUserSysadmin) {
      dispatch(getAllGasStationAdmins());
      dispatch(getAllGasStationManagers());
      dispatch(getAllViewers());
      dispatch(getAllOwners())
      dispatch(getAllClients());
    } else {
      dispatch(getManagersByAdminId());
      dispatch(getAllOwnersForPZAdmin())
      dispatch(getViewersByAdminId());
    }
    return () => {
      dispatch(clearGasStationForEdit());
    };
  }, [dispatch, isLoggedUserSysadmin]);

  const setGasStationAdmin = (id) => {
    setModifyGasStation({
      ...modifyGasStation,
      adminKeycloakId: id,
    });
  };

  const setClientId = (id) => {
      const client = clients.find(x => x.id === id);
      setModifyGasStation({
        ...modifyGasStation,
        clientId: id,
        customer: id === null ? "" : client.name,
      });
    };

  const renderEditManagers = (managersIds) => {
    const getListOfManagers = (managers, ordinalNumber) => {
      if (ordinalNumber === 1) return managers;
      return managers.filter(
        (m) => !managersIds.slice(0, ordinalNumber - 1).includes(m.id)
      );
    };



    return (
      <div className={Style.paddingTop}>
        <div className={Style.section__title}>{t("GasStationDetailsModal.managers")}</div>
        {managersIds.map((manager, index) => (
          <div className={Style.managerListContainer} key={index}>
            <div className={Style.selectManager}>
              <Controller
                name={`parkingZoneManager_${managersComboBoxNames[index]}`}
                control={control}
                render={() => (
                    <Autocomplete
                        size="small"
                        id={`parkingZoneManager_${managersComboBoxNames[index]}`}
                        onChange={(e,value)  => {
                          if(value) {
                            managersIds[index] = value.id;
                            setManagersIds([...managersIds]);
                          }
                        }}
                        disableClearable
                        value = {managers.find(x=>x.id===manager) || null}
                        renderInput={(params) => <TextField {...params} placeholder={"auswählen"}/>}
                        options={getListOfManagers(managers, index + 1).filter((m) => m.id !== modifyGasStation?.keycloakAdminId)}
                        getOptionSelected={(option, value) => option.id === value.id}
                        getOptionLabel={(x) => `${x.firstName} ${x.lastName} | ${x.emailAddress} ${x.companyName?"| "+x.companyName:""}`}
                    />
                )}
              />
            </div>
            <div className={Style.removeManager}>
              <img
                alt=""
                src={XIcon}
                height="25px"
                width="25px"
                onClick={(e) => {
                  setManagersIds([
                    ...managersIds.filter((m, i) => i !== index),
                  ]);
                  managersComboBoxNames.splice(index, 1);
                  setManagersComboBoxNames([...managersComboBoxNames]);
                }}
              />
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderEditViewers = (viewerIds) => {
    const getListOfViewers = (viewers, ordinalNumber) => {
      if (ordinalNumber === 1) return viewers;
      return viewers.filter(
          (m) => !viewerIds.slice(0, ordinalNumber - 1).includes(m.id)
      );
    };

    return (
        <div className={Style.paddingTop}>
          <div className={Style.section__title}>{t("Viewer.Viewers")}</div>
          {viewerIds.map((viewer, index) => (
              <div className={Style.managerListContainer} key={index}>
                <div className={Style.selectManager}>
                  <Controller
                      name={`parkingZoneViewer_${viewersComboBoxNames[index]}`}
                      control={control}
                      render={() => (
                          <Autocomplete
                              size="small"
                              id={`parkingZoneViewer_${viewersComboBoxNames[index]}`}
                              onChange={(e,value)  => {
                                if(value) {
                                  viewerIds[index] = value.id;
                                  setViewersIds([...viewerIds]);
                                }
                              }}
                              disableClearable
                              value = {viewers.find(x=>x.id===viewer) || null}
                              renderInput={(params) => <TextField {...params} placeholder={"auswählen"}/>}
                              options={getListOfViewers(viewers, index + 1).filter((m) => m.id !== modifyGasStation?.keycloakAdminId)}
                              getOptionSelected={(option, value) => option.id === value.id}
                              getOptionLabel={(x) => `${x.firstName} ${x.lastName} | ${x.emailAddress} ${x.companyName?"| "+x.companyName:""}`}
                          />
                      )}
                  />

                </div>
                <div className={Style.removeManager}>
                  <img
                      alt=""
                      src={XIcon}
                      height="25px"
                      width="25px"
                      onClick={(e) => {
                        setViewersIds([
                          ...viewerIds.filter((m, i) => i !== index),
                        ]);
                        viewersComboBoxNames.splice(index, 1);
                        setViewersComboBoxNames([...viewersComboBoxNames]);
                      }}
                  />
                </div>
              </div>
          ))}
        </div>
    );
  };

  const renderEditBeppolicemans = (beppolicemansIds) => {
    const getListOfBeppolicemans = (beppolicemans, ordinalNumber) => {
      if (ordinalNumber === 1) {
        return beppolicemans;
      }
      return beppolicemans.filter(
          (m) => !beppolicemansIds.slice(0, ordinalNumber - 1).includes(m.id)
      );
    };

    return (
        <div className={Style.paddingTop}>
          <div className={Style.section__title}>
            {t("GasStationDetailsModal.beppolicemans")}
          </div>
          {beppolicemansIds.map((beppoliceman, index) => (
              <div className={Style.managerListContainer} key={index}>
                <div className={Style.selectManager}>
                  <Controller
                      name={`gasStationBeppoliceman_${beppolicemansComboBoxNames[index]}`}
                      control={control}
                      render={() => (
                          <select
                              type="text"
                              className={cn(
                                  Style.textStyleSelectEditModal,
                                  Style.noArrowSelect
                              )}
                              name={`gasStationBeppoliceman_${beppolicemansComboBoxNames[index]}`}
                              onChange={(e) => {
                                beppolicemansIds[index] = e.target.value;
                                setBeppolicemansIds([...beppolicemansIds]);
                              }}
                          >
                            {getListOfBeppolicemans(beppolicemans, index + 1).map(
                                (user, index) => {
                                  return (
                                      user.id === beppoliceman && (
                                          <option
                                              value={beppoliceman}
                                              key={index + 1}
                                              selected
                                          >
                                            {user.firstName} {user.lastName}
                                          </option>
                                      )
                                  );
                                }
                            )}
                          </select>
                      )}
                  />
                </div>
                <div className={Style.removeManager}>
                  <img
                      alt="X"
                      src={XIcon}
                      height="25px"
                      width="25px"
                      onClick={(e) => {
                        deletedBeppolicemansIds.push(
                            beppolicemansIds.find((b, i) => i === index)
                        );
                        setDeletedBeppolicemansIds([...deletedBeppolicemansIds]);

                        setBeppolicemansIds([
                          ...beppolicemansIds.filter((m, i) => i !== index),
                        ]);
                        beppolicemansComboBoxNames.splice(index, 1);
                        setBeppolicemansComboBoxNames([
                          ...beppolicemansComboBoxNames,
                        ]);
                      }}
                  />
                </div>
              </div>
          ))}
        </div>
    );
  };


  const isSubmitDisabled =
    !modifyGasStation?.address ||
    !modifyGasStation?.name ||
    modifyGasStation?.adminKeycloakId === "0" ||
    managersIds?.includes("0") ||
    managersIds?.includes(modifyGasStation?.keycloakAdminId) ||
    viewersIds?.includes("0") ||
    viewersIds?.includes(modifyGasStation?.keycloakAdminId);

  const saveGasStation = async (data) => {
    const formData = new FormData();

    formData.append("powerOfAttorney", powerOfAttorney && powerOfAttorney[0]);
    formData.append("powerOfAttorneyName", powerOfAttorneyName);
    for (let i = 0; i < documentation?.length; i++) {
          formData.append("documentation", documentation[i]);
    }
    formData.append("documentationName", documentationName);

    const {
      intentAdditionalFee,
      intentPaymentPeriod,
      intentReminderFee,
      intentReminderPaymentPeriod,
      intentLastReminderFee,
      intentLastReminderPaymentPeriod,
      intentPartialPwfCashAdditionalFee,
      intentPartialPwfCashPaymentPeriod,
      intentPartialPwfCashReminderFee,
      intentPartialPwfCashRemPayPer,
      intentPartialCashLastReminderFee,
      intentPartialCashLastRemPayPer,
      intentPartialPwfCardAdditionalFee,
      intentPartialPwfCardPaymentPeriod,
      intentPartialPwfCardReminderFee,
      intentPartialPwfCardRemPayPer,
      intentPartialCardLastReminderFee,
      intentPartialCardLastRemPayPer,
      intentCardPaymentAdditionalFee,
      intentCardPaymentPaymentPeriod,
      intentCardPaymentReminderFee,
      intentCardPaymentReminderPaymentPeriod,
      intentCardPaymentLastReminderFee,
      intentCardPaymentLastReminderPeriod,
      promissoryNotePaymentFee,
      promissoryNoteGracePeriod,
      promissoryNoteAdditionalFee,
      promissoryNotePaymentPeriod,
      promissoryNoteReminderFee,
      promissoryNoteReminderPaymentPeriod,
      promissoryNoteLastReminderFee,
      promissoryNoteLastReminderPeriod,
      debtNoteAdditionalFee,
      debtNotePaymentPeriod,
      debtNoteReminderFee,
      debtNoteReminderPaymentPeriod,
      debtNoteLastReminderFee,
      debtNoteLastReminderPeriod,
      pumpSwappedAdditionalFee,
      pumpSwappedPaymentPeriod,
      pumpSwappedReminderFee,
      pumpSwappedReminderPaymentPeriod,
      pumpSwappedLastReminderFee,
      pumpSwappedLastReminderPeriod,
      otherReasonAdditionalFee,
      otherReasonPaymentPeriod,
      otherReasonReminderFee,
      otherReasonReminderPaymentPeriod,
      otherReasonLastReminderFee,
      otherReasonLastReminderPeriod
    } = data;
    const categoryPaymentDetails = {
      intentAdditionalFee : countryWatch == "CH" ? intentAdditionalFee : 0,
      intentPaymentPeriod: countryWatch == "CH" ? intentPaymentPeriod : 0,
      intentReminderFee: countryWatch == "CH" ? intentReminderFee : 0,
      intentReminderPaymentPeriod: countryWatch == "CH" ? intentReminderPaymentPeriod : 0,
      intentLastReminderFee: countryWatch == "CH" ? intentLastReminderFee : 0,
      intentLastReminderPaymentPeriod: countryWatch == "CH" ? intentLastReminderPaymentPeriod : 0,
      promissoryNotePaymentFee,
      promissoryNoteGracePeriod,
      promissoryNoteAdditionalFee,
      promissoryNotePaymentPeriod,
      promissoryNoteReminderFee,
      promissoryNoteReminderPaymentPeriod,
      promissoryNoteLastReminderFee,
      promissoryNoteLastReminderPeriod,
      debtNoteAdditionalFee : countryWatch == "CH" ? debtNoteAdditionalFee : 0,
      debtNotePaymentPeriod: countryWatch == "CH" ? debtNotePaymentPeriod : 0,
      debtNoteReminderFee: countryWatch == "CH" ? debtNoteReminderFee : 0,
      debtNoteReminderPaymentPeriod: countryWatch == "CH" ? debtNoteReminderPaymentPeriod : 0,
      debtNoteLastReminderFee: countryWatch == "CH" ? debtNoteLastReminderFee : 0,
      debtNoteLastReminderPeriod: countryWatch == "CH" ? debtNoteLastReminderPeriod : 0,
      pumpSwappedAdditionalFee: countryWatch == "CH" ? pumpSwappedAdditionalFee : 0,
      pumpSwappedPaymentPeriod: countryWatch == "CH" ? pumpSwappedPaymentPeriod : 0,
      pumpSwappedReminderFee: countryWatch == "CH" ? pumpSwappedReminderFee : 0,
      pumpSwappedReminderPaymentPeriod: countryWatch == "CH" ? pumpSwappedReminderPaymentPeriod : 0,
      pumpSwappedLastReminderFee: countryWatch == "CH" ? pumpSwappedLastReminderFee : 0,
      pumpSwappedLastReminderPeriod: countryWatch == "CH" ? pumpSwappedLastReminderPeriod : 0,
      otherReasonAdditionalFee,
      otherReasonPaymentPeriod,
      otherReasonReminderFee,
      otherReasonReminderPaymentPeriod,
      otherReasonLastReminderFee,
      otherReasonLastReminderPeriod,
    };

    const gasStationForEdit = {
      ...modifyGasStation,
      categoryPaymentDetails,
      managersIds,
      viewersIds,
      deletedBeppolicemansIds,
      beppolicemansIds,
      useClientDocs,
      serviceFee: isSelectedCountryDE() ? serviceFee : null,
      holderDataRetrieval: isSelectedCountryDE() ? holderDataRetrieval : null,
      invoicePaymentPeriod: !isSelectedCountryCH() ? invoicePaymentPeriod : null,
      reminderPaymentPeriod: !isSelectedCountryCH() ? reminderPaymentPeriod : null,
      lastReminderPaymentPeriod: !isSelectedCountryCH() ? lastReminderPaymentPeriod : null,
      rvgMultiplierInvoice: isSelectedCountryDE() ? rvgMultiplierInvoice : null,
      rvgMultiplierReminder: isSelectedCountryDE() ? rvgMultiplierReminder : null,
      rvgMultiplierLastReminder: isSelectedCountryDE() ? rvgMultiplierLastReminder : null,
      baseFee: isSelectedCountryDE() ? baseFee : null,
      capBelow50: isSelectedCountryDE() ? capBelow50 : null,
      labelNames: selectedLabels,
      pricingStructure,
      internationalFee: !isSelectedCountryAT()? modifyGasStation.internationalFee : 0,
      marker: {
        latitude: modifyGasStation.marker?.center?.lat,
        longitude: modifyGasStation.marker?.center?.lng
      },
    };

    for (let i = 0; i < aralFuelTypesTransformed.length; i++) {
      if(fuelTypesSelected[aralFuelTypesTransformed[i]]) {
        gasStationForEdit.aralFuelTypes =  (gasStationForEdit.aralFuelTypes? gasStationForEdit.aralFuelTypes : "")  + aralFuelTypesTransformed[i] + ',';
      }
    }
    if (gasStationForEdit.aralFuelTypes!=null && gasStationForEdit.aralFuelTypes.charAt( gasStationForEdit.aralFuelTypes.length-1)===',') {
      gasStationForEdit.aralFuelTypes = gasStationForEdit.aralFuelTypes.substring(0, gasStationForEdit.aralFuelTypes.length-1);
    }
    formData.append(
      "gasStationZone",
      new Blob([JSON.stringify(gasStationForEdit)], {
        type: "application/json",
      })
    );

    await dispatch(
      editGasStation(gasStationForUpdate.id, formData, props.onClose)
    );
  };

  const handleWaitingPeriod = (value) => {
    let newWaitingPeriod = isAralDeClientId(value)? 7 : 3
    setModifyGasStation(prev => ({ ...prev, waitingPeriod: newWaitingPeriod}));
    setValue("waitingPeriod", newWaitingPeriod, { shouldValidate: true, shouldDirty: true });
  };

  const currencyDisplay = formatCurrencyCode(countryWatch);

  const internationalFeeLabel = t("GasStations.internationalFee") + " " + currencyDisplay;
  const additionalFeeLabel = t("GasStations.additionalFee") + " " + currencyDisplay;
  const reminderFeeLabel = t("GasStations.reminderFee") + " " + currencyDisplay;
  const lastReminderFeeLabel = t("GasStations.lastReminderFee")  + " " + currencyDisplay;
  const paymentFeeLabel = t("GasStations.paymentFee") + " " + currencyDisplay;
  const serviceFeeLabel = t("GasStations.serviceFee") + " " + currencyDisplay;
  const holderDataRetrievalLabel = t("GasStations.holderDataRetrieval") + " " + currencyDisplay;
  const baseFeeLabel = t("GasStations.baseFee") + " " + currencyCode(countryWatch);
  const capBelow50Label = t("GasStations.capBelow50") + " " + currencyCode(countryWatch);

  return (
    <Modal
      open={props.open}
      closeOnEsc
      onClose={props.onClose}
      center
      styles={newModalStyle({ width: "70%", maxWidth: "900px" })}
    >
      <div className="modal__headerLine" />
      <div className={cn("modal__title", Style.modal__title)}>
        <div>{t("EditGasStationModal.title")}</div>
        {getClientLogo(modifyGasStation?.clientId)}
      </div>
      {isLoading && <ModalLoadingIndicator />}
      <form onSubmit={handleSubmit(saveGasStation)}>
        <div className={Style.formContainer}>

          <div className={Style.section}>
            <div className={Style.section__title}>
              {t("EditGasStationModal.basicInfo")}
            </div>

            <div className={Style.rowContainer}>
              <div className={Style.container}>
                <LabelWithHR label={t("EditGasStationModal.number")}/>
                <Controller
                    name="number"
                    control={control}
                    render={() => (
                        <input
                            type={"text"}
                            className={Style.textStyleInputEditModalDisabled}
                            name="number"
                            defaultValue={modifyGasStation.number}
                            disabled
                        />
                    )}
                />
              </div>

              <div className={Style.nameContainer}>
                <div className={cn(Style.container)}>
                  <LabelWithHR label={t("EditGasStationModal.name")}/>
                  <Controller
                      name="name"
                      control={control}
                      render={() => (
                          <input
                              type={"text"}
                              className={Style.textStyleInputEditModal}
                              name="name"
                              onChange={(e) => {
                                setModifyGasStation({
                                  ...modifyGasStation,
                                  name: e.target.value,
                                });
                              }}
                              defaultValue={modifyGasStation?.name}
                          />
                      )}
                  />
                </div>
              </div>

              {/*put client name to this row if there is no client entity*/}
              {!isAralDeClientId(modifyGasStation?.clientId) &&
                  <div className={Style.nameContainer}>
                    <div className={cn(Style.container)}>
                      <LabelWithHR label={t("Clients.Client")}/>
                      <Controller
                          name="customer"
                          control={control}
                          render={({field}) => (
                              <input
                                  type={"text"}
                                  className={modifyGasStation?.clientId ? Style.textStyleInputEditModalDisabled : Style.textStyleInputEditModal}
                                  name="customer"
                                  onChange={(e) => {
                                    setModifyGasStation({
                                      ...modifyGasStation,
                                      customer: e.target.value,
                                    });
                                    field.onChange(e);
                                  }}
                                  defaultValue={modifyGasStation?.customer}
                                  disabled={modifyGasStation?.clientId}
                                  value={modifyGasStation?.customer}
                              />
                          )}
                      />
                    </div>
                  </div>}
            </div>

            {/*put client details to another row when client entity is present*/}
            {isAralDeClientId(modifyGasStation?.clientId) &&
                <div className={Style.rowContainer}>

                  <div className={cn(Style.container)}>
                    <LabelWithHR
                        label={t("EditGasStationModal.externalReferenceId", {customer: modifyGasStation?.customer})}/>
                    <Controller
                        name="externalReferenceId"
                        control={control}
                        render={() => (
                            <input
                                type={"text"}
                                className={isAralDeClientId(modifyGasStation?.clientId) ? Style.textStyleInputEditModalDisabled : Style.textStyleInputEditModal}
                                disabled={isAralDeClientId(modifyGasStation?.clientId)}
                                name="externalReferenceId"
                                onChange={(e) => {
                                  setModifyGasStation({
                                    ...modifyGasStation,
                                    externalReferenceId: e.target.value,
                                  });
                                }}
                                defaultValue={modifyGasStation?.externalReferenceId}
                            />
                        )}
                    />
                  </div>

                  <div className={Style.nameContainer}>
                    <div className={cn(Style.container)}>
                      <LabelWithHR label={t("Clients.Client")}/>
                      <Controller
                          name="customer"
                          control={control}
                          render={() => (
                              <input
                                  type={"text"}
                                  className={Style.textStyleInputEditModalDisabled}
                                  name="customer"
                                  defaultValue={modifyGasStation?.customer}
                                  disabled
                                  value={modifyGasStation?.customer}
                              />
                          )}
                      />
                    </div>
                  </div>

                </div>}

            <div className={Style.rowContainer}>
              <div className={cn(Style.container, Style["container--margineRightSmall"])}>
                <LabelWithHR label={t("EditGasStationModal.clientNumber")}/>
                <Controller
                    name="clientNumber"
                    control={control}
                    render={() => (
                        <input
                            type={"text"}
                            className={Style.textStyleInputEditModal}
                            name="clientNumber"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                clientNumber: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.clientNumber}
                        />
                    )}
                />
              </div>
              <div className={cn(Style.container)}>
                <LabelWithHR label={t("EditGasStationModal.clientName")}/>
                <Controller
                    name="clientName"
                    control={control}
                    render={() => (
                        <input
                            type={"text"}
                            className={Style.textStyleInputEditModal}
                            name="clientName"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                clientName: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.clientName}
                        />
                    )}
                />
              </div>
            </div>
            <div className={Style.rowContainer}>
              <div className={cn(Style.container, Style["container--margineRightSmall"])}>
                <LabelWithHR label={t("EditGasStationModal.profitCenter")}/>
                <Controller
                    name="profitCenter"
                    control={control}
                    render={() => (
                        <input
                            type={"text"}
                            className={Style.textStyleInputEditModal}
                            name="profitCenter"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                profitCenter: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.profitCenter}
                        />
                    )}
                />
              </div>
              <div className={cn(Style.container)}>
                <LabelWithHR label={t("EditGasStationModal.costCenter")}/>
                <Controller
                    name="costCenter"
                    control={control}
                    render={() => (
                        <input
                            type={"text"}
                            className={Style.textStyleInputEditModal}
                            name="costCenter"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                costCenter: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.costCenter}
                        />
                    )}
                />
              </div>
            </div>

            <div className={Style.rowContainer}>
              {!isSelectedCountryAT() && <div className={cn(Style.container, Style["container--margineRightSmall"])}>
                <LabelWithHR label={internationalFeeLabel}/>
                  <Controller
                      name="internationalFee"
                      control={control}
                      render={() => (
                          <input
                              type={"number"}
                              className={Style.textStyleInputEditModal}
                              name="internationalFee"
                              onChange={(e) => {
                                setModifyGasStation(prev => ({ ...prev, internationalFee: Number(e.target.value) }));
                              }}
                              defaultValue={modifyGasStation?.internationalFee}
                          />
                      )}
                  />
              </div>}
              <div className={cn(Style.container)}>
                <LabelWithHR label={t("EditGasStationModal.waitingPeriod")}/>
                <Controller
                  name="waitingPeriod"
                  control={control}
                  render={({ field }) => (
                      <input
                          type="number"
                          className={Style.textStyleInputEditModal}
                          {...field} 
                          required={true}
                          defaultValue={modifyGasStation?.waitingPeriod}
                          onChange={(e) => {
                              field.onChange(e);
                              setModifyGasStation(prev => ({ ...prev, waitingPeriod: Number(e.target.value) }));
                          }}
                      />
                  )}
              />
              </div>
              </div>
              <div className={Style.customInputsContainer}>
                <div className={Style.automationCheckboxes}>
                  <div className="objectionEnabledCheckbox">
                    <input
                        type="checkbox"
                        className="checkboxObjectionEnabled"
                        onChange={(e) => {
                          setModifyGasStation({
                            ...modifyGasStation,
                            interruptAutoBilling:
                                !modifyGasStation?.interruptAutoBilling,
                          });
                        }}
                        checked={
                          modifyGasStation?.interruptAutoBilling
                        }
                    />
                    <div
                        className="objectionEnabled"
                        style={{ fontSize: 14 }}
                    >
                      {t("GasStations.interruptAutoBillingGeneration")}
                    </div>
                  </div>
                  <div className="objectionEnabledCheckbox">
                    <input
                      type="checkbox"
                      className="checkboxObjectionEnabled"
                      onChange={() => {
                        setModifyGasStation({
                          ...modifyGasStation,
                          hdStatusAutomation: !modifyGasStation?.hdStatusAutomation,
                        });
                      }}
                      checked={modifyGasStation?.hdStatusAutomation}
                    />
                    <div className="objectionEnabled" style={{ fontSize: 14 }}>
                      {t("GasStations.hdStatusAutomation")}
                    </div>
                  </div>
                </div>
              </div>

              <div className={Style.customInputsContainer}>
                <FormControl component="fieldset" style={{ width: "100%" }}>
                  <LabelWithHR label={t("GasStations.debtNoteType")}/>
                  <RadioGroup
                    name="debtNoteType"
                    value={modifyGasStation?.debtNoteType}
                    onChange={(e) => {
                      setModifyGasStation({
                        ...modifyGasStation,
                        debtNoteType: e.target.value,
                      });
                    }}
                    row
                  >
                    <FormControlLabel
                      value={DebtNoteType.BEPPO}
                      control={<Radio />}
                      label={t("GasStations.DebtNoteType.BEPPO")}
                    />
                    <FormControlLabel
                      value={DebtNoteType.GAS_STATION}
                      control={<Radio />}
                      label={t("GasStations.DebtNoteType.GAS_STATION")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
          </div>

          <div className={Style.section}>
            <AddressesComponent
                onAddressAdded={onAddressAdded}
                initialAddress={modifyGasStation?.address}
                watch={watch}
                register={register}
                useGeocode={false}
                errors={errors}
                countryEditable={false}
            />
            <LabelWithHR label={t("GasStations.location")} />
            <div className={Style.section__map}>
              <GoogleMapReact
                  defaultCenter={
                      (modifyGasStation?.marker &&
                          modifyGasStation?.marker?.center) ||
                      defaultMarker.center
                  }
                  defaultZoom={
                    modifyGasStation?.marker &&
                        modifyGasStation?.marker?.center
                        ? 17
                        : defaultMarker.zoom
                  }
                  yesIWantToUseGoogleMapApiInternals
                  options={modifyGasStation?.marker ? colorMapOptions : dimmedMapOptions}
                  onClick={(value) => {
                    if (!manualParkingZoneMarkerEnabled) {
                      return;
                    }

                    if (modifyGasStation?.marker) {
                      return;
                    }
                    setModifyGasStation({
                      ...modifyGasStation,
                      marker:
                        {center: {lat: value.lat, lng: value.lng}},
                    });
                  }}
                  bootstrapURLKeys={{
                    key: process.env.REACT_APP_GOOGLE_MAPS_KEY,
                    libraries: ["geocoding"],
                    language: i18n.language,
                  }}
                  onGoogleApiLoaded={({map, maps}) => {
                    setMap(map);
                    setGeocoder(new maps.Geocoder());
                  }}
                  onTilesLoaded={onTilesLoaded}

              >
                {modifyGasStation.marker && (
                   <Marker
                     lat={modifyGasStation.marker.center?.lat}
                     lng={modifyGasStation.marker.center?.lng}
                     key={modifyGasStation.marker.center?.lat + modifyGasStation.marker.center?.lng}
                     onClick={() => {
                       if (!manualParkingZoneMarkerEnabled) {
                         return;
                       }
                       setModifyGasStation({
                         ...modifyGasStation,
                         marker: null,
                       });
                     }}
                   />
                 )}
              </GoogleMapReact>
            </div>
          </div>

          <div className={Style.section}>
            <div className={cn(Style.section__title, Style.paddingTop)}>
              {t("Clients.Client")}
            </div>
            {isLoggedUserSysadmin ? (
                <div>
                  <div className={Style.managerListContainer}>
                    <div className={Style.selectManager}>
                      <Controller
                          name="clientId"
                          control={control}
                          render={() => (
                              <Autocomplete
                                  size="small"
                                  id={"clientId"}
                                  onChange={(e, value) => {
                                    if (value) {
                                      setClientId(value.id);
                                      setValue("customer", `${value.name}`);
                                      resetSelectedFuelTypes();
                                      handleWaitingPeriod(value.id);
                                    }
                                  }}
                                  disableClearable
                                  value={clients.find(x => x.id === modifyGasStation?.clientId) || null}
                                  renderInput={(params) => <TextField {...params} placeholder={t("Clients.Choose")} disabled={isAralDeClientId(modifyGasStation.clientId)}/>}
                                  options={clients}
                                  getOptionSelected={(option, value) => option.id === value.id}
                                  getOptionLabel={(x) => `${x.name} | ${x.representativeName}`}
                                  disabled={isAralDeClientId(modifyGasStation.clientId)}
                              />
                          )}
                      />
                    </div>
                    {!isAralDeClientId(modifyGasStation.clientId) && (
                    <div className={Style.removeManager} onClick={() => {
                      setClientId(null);
                      setUseClientDocs(false);
                      setValue("customer", "");
                    }}>
                      <img
                          alt=""
                          src={XIcon}
                          height="25px"
                          width="25px"
                      />
                    </div>
                    )}
                  </div>
                  <div className="objectionEnabledCheckbox">
                    <input
                        type="checkBox"
                        className="checkboxObjectionEnabled"
                        disabled={!modifyGasStation?.clientId || isAralDeClientId(modifyGasStation.clientId)}
                        onChange={() => {
                          setUseClientDocs(
                              !useClientDocs
                          );
                        }}
                        checked={useClientDocs}
                    />
                    <div
                        className="objectionEnabled"
                        style={{fontSize: 14}}
                    >
                      {t("Clients.UseClientDocs")}
                    </div>
                  </div>
                </div>
            ) : (
                <div className={Style.text}>
                  {clients.find(client => client.id === modifyGasStation.client.id)?.name || ""}
                </div>
            )}

          <AutoCompleteWithTags
            suggestions={gasStationForUpdate.labelsSuggestions || []}
            selectedValues={selectedLabels}
            label={t("GasStations.labels")}
            placeholder={t("GasStations.labelPlaceholderText")}
            onSelectionChange={(selectedValues) => {
              console.log('Selected labels:', selectedValues);
              setSelectedLabels(selectedValues);
            }}
          />
          {pricingStructure && (
            <PricingStructureTable 
              pricingStructure={pricingStructure}
              currencyDisplay={currencyDisplay}
              onPricingValueUpdate={updatePricingValue}
              disabled={false}
              showWrapper={false}
              countryCode={modifyGasStation?.address?.countryCode || "AT"}
            />
          )}

          </div>

          {isAralDeClientId(modifyGasStation.clientId) && (
            <div className={Style.section}>
              <div className={Style.section__title}>
                {t("GasStations.fuelTypesTitle")}
              </div>
              <div  className="fuel-checkbox-container">
              {aralFuelTypesTransformed.map((value, index) => (
                  <div className="objectionEnabledCheckbox">
                    <input
                        key={index}
                        type="checkBox"
                        className="checkboxObjectionEnabled"
                        onChange={(e) => handleFuelTypesChange(value, e.target.checked)}
                        checked={fuelTypesSelected[value]}
                    />
                    <div
                        className="objectionEnabled"
                        style={{fontSize: 14}}
                    >
                      {value}
                    </div>
                  </div>
              ))}
              </div>
            </div>
          )}
          {isSelectedCountryCH() ? (
              <>
              <div className={Style.section}>
                <div className={Style.section__title}>
                  {t("GasStations.inetntPaymentInfoTitle")}
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={additionalFeeLabel}
                      name={"intentAdditionalFee"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.intentAdditionalFee}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.paymentPeriod")}
                      name={"intentPaymentPeriod"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.intentPaymentPeriod}
                  />
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={reminderFeeLabel}
                      name={"intentReminderFee"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.intentReminderFee}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.reminderPaymentPeriod")}
                      name={"intentReminderPaymentPeriod"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={
                        categoryPaymentDetails?.intentReminderPaymentPeriod
                      }
                  />
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={lastReminderFeeLabel}
                      name={"intentLastReminderFee"}
                      defaultValue={categoryPaymentDetails?.intentLastReminderFee}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.lastReminderPaymentPeriod")}
                      name={"intentLastReminderPaymentPeriod"}
                      defaultValue={categoryPaymentDetails?.intentLastReminderPaymentPeriod}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                  />
                </div>
              </div>

              <div className={Style.section}>
                <div className={Style.section__title}>
                  {t("GasStations.promissoryNotePaymentInfoTitle")}
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={paymentFeeLabel}
                      name={"promissoryNotePaymentFee"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={
                        categoryPaymentDetails?.promissoryNotePaymentFee
                      }
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.gracePeriod")}
                      name={"promissoryNoteGracePeriod"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.promissoryNoteGracePeriod}
                  />
                </div>

                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={additionalFeeLabel}
                      name={"promissoryNoteAdditionalFee"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={
                        categoryPaymentDetails?.promissoryNoteAdditionalFee
                      }
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.paymentPeriod")}
                      name={"promissoryNotePaymentPeriod"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={
                        categoryPaymentDetails?.promissoryNotePaymentPeriod
                      }
                  />
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={reminderFeeLabel}
                      name={"promissoryNoteReminderFee"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.promissoryNoteReminderFee}
                  />
                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.reminderPaymentPeriod")}
                      name={"promissoryNoteReminderPaymentPeriod"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={
                        categoryPaymentDetails?.promissoryNoteReminderPaymentPeriod
                      }
                  />
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={lastReminderFeeLabel}
                      name={"promissoryNoteLastReminderFee"}
                      defaultValue={categoryPaymentDetails?.promissoryNoteLastReminderFee}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.lastReminderPaymentPeriod")}
                      name={"promissoryNoteLastReminderPeriod"}
                      defaultValue={categoryPaymentDetails?.promissoryNoteLastReminderPeriod}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                  />
                </div>
              </div>

              <div className={Style.section}>
                <div className={Style.section__title}>
                  {t("GasStations.debtNotePaymentInfoTitle")}
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={additionalFeeLabel}
                      name={"debtNoteAdditionalFee"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.debtNoteAdditionalFee}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.paymentPeriod")}
                      name={"debtNotePaymentPeriod"}
                      rules={{
                        validate: (value) => getValues("country") !== "CH" || Number(value) >= 1
                            || t("Validation.debtNotePaymentPeriodMinCh"),
                      }}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.debtNotePaymentPeriod}
                  />
                </div>

                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={reminderFeeLabel}
                      name={"debtNoteReminderFee"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.debtNoteReminderFee}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.reminderPaymentPeriod")}
                      name={"debtNoteReminderPaymentPeriod"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={
                        categoryPaymentDetails?.debtNoteReminderPaymentPeriod
                      }
                  />
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={lastReminderFeeLabel}
                      name={"debtNoteLastReminderFee"}
                      defaultValue={categoryPaymentDetails?.debtNoteLastReminderFee}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.lastReminderPaymentPeriod")}
                      name={"debtNoteLastReminderPeriod"}
                      defaultValue={categoryPaymentDetails?.debtNoteLastReminderPeriod}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                  />
                </div>
              </div>

              <div className={Style.section}>
                <div className={Style.section__title}>
                  {t("GasStations.pumpSwappedPaymentInfoTitle")}
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={additionalFeeLabel}
                      name={"pumpSwappedAdditionalFee"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.pumpSwappedAdditionalFee}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.paymentPeriod")}
                      name={"pumpSwappedPaymentPeriod"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.pumpSwappedPaymentPeriod}
                  />
                </div>

                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={reminderFeeLabel}
                      name={"pumpSwappedReminderFee"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.pumpSwappedReminderFee}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.reminderPaymentPeriod")}
                      name={"pumpSwappedReminderPaymentPeriod"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={
                        categoryPaymentDetails?.pumpSwappedReminderPaymentPeriod
                      }
                  />
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={lastReminderFeeLabel}
                      name={"pumpSwappedLastReminderFee"}
                      defaultValue={categoryPaymentDetails?.pumpSwappedLastReminderFee}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.lastReminderPaymentPeriod")}
                      name={"pumpSwappedLastReminderPeriod"}
                      defaultValue={categoryPaymentDetails?.pumpSwappedLastReminderPeriod}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                  />
                </div>
              </div>

              <div className={Style.section}>
                <div className={Style.section__title}>
                  {t("GasStations.otherReasonPaymentInfoTitle")}
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={additionalFeeLabel}
                      name={"otherReasonAdditionalFee"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.otherReasonAdditionalFee}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.paymentPeriod")}
                      name={"otherReasonPaymentPeriod"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.otherReasonPaymentPeriod}
                  />
                </div>

                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={reminderFeeLabel}
                      name={"otherReasonReminderFee"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={categoryPaymentDetails?.otherReasonReminderFee}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.reminderPaymentPeriod")}
                      name={"otherReasonReminderPaymentPeriod"}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                      defaultValue={
                        categoryPaymentDetails?.otherReasonReminderPaymentPeriod
                      }
                  />
                </div>
                <div className={Style.rowContainer}>
                  <InputController
                      containerStyles={cn(
                          Style.container,
                          Style["container--margineRight"]
                      )}
                      label={lastReminderFeeLabel}
                      name={"otherReasonLastReminderFee"}
                      defaultValue={categoryPaymentDetails?.otherReasonLastReminderFee}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                  />

                  <InputController
                      containerStyles={Style.container}
                      label={t("GasStations.lastReminderPaymentPeriod")}
                      name={"otherReasonLastReminderPeriod"}
                      defaultValue={categoryPaymentDetails?.otherReasonLastReminderPeriod}
                      control={control}
                      controllerClassName={Style.textStyleInputEditModal}
                      type={"number"}
                      min={0}
                  />
                </div>
              </div>
            </>
            ) : (
            <>
                <div className={Style.section}>
                    <div className={Style.section__title}>
                      {t("GasStations.paymentAndFeeDetails")}
                    </div>
                      {isSelectedCountryDE() && <div className={Style.gsPaymentInfoContainer}>
                        <div className={cn(
                            Style.container,
                            Style["container--margineRight"],
                        )}>
                          <InputFieldWithLabel
                            className={Style.textStyleInputEditModal}
                            label={serviceFeeLabel}
                            name={"serviceFee"}
                            registerName={"serviceFee"}
                            register={register}
                            type="number"
                            min={0}
                            required={isSelectedCountryDE()}
                            validationProps={isSelectedCountryDE() ? {
                                required: t("Validation.required"),
                                min: { value: 0, message: t("Validation.minValueZero") }
                              }
                              :{}}
                            errors={errors}
                          />
                        </div>

                        <div className={Style.container}>
                          <InputFieldWithLabel
                            className={Style.textStyleInputEditModal}
                            label={holderDataRetrievalLabel}
                            name={"holderDataRetrieval"}
                            registerName={"holderDataRetrieval"}
                            register={register}
                            type={"number"}
                            min={0}
                            required={isSelectedCountryDE()}
                            validationProps={isSelectedCountryDE() ? {
                                required: t("Validation.required"),
                                min: { value: 0, message: t("Validation.minValueZero") }
                              }
                              :{}}
                            errors={errors}
                          />
                        </div>
                      </div>}

                      <div className={Style.gsPaymentInfoContainer}>
                        {isSelectedCountryDE() &&<div className={cn(
                            Style.container,
                            Style["container--margineRight"]
                        )}>
                          <InputFieldWithLabel
                            className={Style.textStyleInputEditModal}
                            label={t("GasStations.rvgMultiplierInvoice")}
                            name={"rvgMultiplierInvoice"}
                            registerName={"rvgMultiplierInvoice"}
                            register={register}
                            type={"number"}
                            min={0}
                            required={isSelectedCountryDE()}
                            validationProps={isSelectedCountryDE() ? {
                                required: t("Validation.required"),
                                min: { value: 0, message: t("Validation.minValueZero") }
                              }
                              :{}}
                            errors={errors}
                        /></div>}

                        <div className={Style.container}>
                          <InputFieldWithLabel
                            className={Style.textStyleInputEditModal}
                            label={t("GasStations.paymentPeriod")}
                            name={"invoicePaymentPeriod"}
                            registerName={"invoicePaymentPeriod"}
                            register={register}
                            type={"number"}
                            min={0}
                            required={!isSelectedCountryCH()}
                            validationProps={!isSelectedCountryCH() ? {
                                required: t("Validation.required"),
                                min: { value: 0, message: t("Validation.minValueZero") }
                              }
                              :{}}
                            errors={errors}
                          />
                        </div>
                      </div>

                      <div className={Style.gsPaymentInfoContainer}>
                        {isSelectedCountryDE() && <div className={cn(
                            Style.container,
                            Style["container--margineRight"]
                        )}>
                          <InputFieldWithLabel
                            className={Style.textStyleInputEditModal}
                            label={t("GasStations.rvgMultiplierReminder")}
                            name={"rvgMultiplierReminder"}
                            registerName={"rvgMultiplierReminder"}
                            register={register}
                            type={"number"}
                            min={0}
                            required={isSelectedCountryDE()}
                            validationProps={isSelectedCountryDE() ? {
                                required: t("Validation.required"),
                                min: { value: 0, message: t("Validation.minValueZero") }
                              }
                              :{}}
                            errors={errors}
                        /></div>}

                        <div className={Style.container}>
                          <InputFieldWithLabel
                            className={Style.textStyleInputEditModal}
                            label={t("GasStations.reminderPaymentPeriod")}
                            name={"reminderPaymentPeriod"}
                            registerName={"reminderPaymentPeriod"}
                            register={register}
                            type={"number"}
                            min={0}
                            required={!isSelectedCountryCH()}
                            validationProps={!isSelectedCountryCH() ? {
                                required: t("Validation.required"),
                                min: { value: 0, message: t("Validation.minValueZero") }
                              }
                              :{}}
                            errors={errors}
                          />
                        </div>
                      </div>

                      <div className={Style.gsPaymentInfoContainer}>
                        {isSelectedCountryDE() &&<div className={cn(
                            Style.container,
                            Style["container--margineRight"]
                        )}>
                          <InputFieldWithLabel
                            className={Style.textStyleInputEditModal}
                            label={t("GasStations.rvgMultiplierLastReminder")}
                            name={"rvgMultiplierLastReminder"}
                            registerName={"rvgMultiplierLastReminder"}
                            register={register}
                            type={"number"}
                            min={0}
                            required={isSelectedCountryDE()}
                            validationProps={isSelectedCountryDE() ? {
                                required: t("Validation.required"),
                                min: { value: 0, message: t("Validation.minValueZero") }
                              }
                              :{}}
                            errors={errors}
                        /></div>}

                        <div className={Style.container}>
                          <InputFieldWithLabel
                            className={Style.textStyleInputEditModal}
                            label={t("GasStations.lastReminderPaymentPeriod")}
                            name={"lastReminderPaymentPeriod"}
                            registerName={"lastReminderPaymentPeriod"}
                            register={register}
                            type={"number"}
                            min={0}
                            required={!isSelectedCountryCH()}
                            validationProps={!isSelectedCountryCH() ? {
                                required: t("Validation.required"),
                                min: { value: 0, message: t("Validation.minValueZero") }
                              }
                              :{}}
                            errors={errors}
                          />
                        </div>
                      </div>

                      {isSelectedCountryDE() &&<div className={Style.gsPaymentInfoContainer}>
                        <div className={cn(
                            Style.container,
                            Style["container--margineRight"]
                        )}>
                          <InputFieldWithLabel
                            className={Style.textStyleInputEditModal}
                            label={baseFeeLabel}
                            name={"baseFee"}
                            registerName={"baseFee"}
                            register={register}
                            type={"number"}
                            min={0}
                            required={isSelectedCountryDE()}
                            validationProps={isSelectedCountryDE() ? {
                                required: t("Validation.required"),
                                min: { value: 0, message: t("Validation.minValueZero") }
                              }
                              :{}}
                            errors={errors}
                        /></div>

                        <div className={Style.container}>
                          <InputFieldWithLabel
                            className={Style.textStyleInputEditModal}
                            label={capBelow50Label}
                            name={"capBelow50"}
                            registerName={"capBelow50"}
                            register={register}
                            type={"number"}
                            min={0}
                            required={isSelectedCountryDE()}
                            validationProps={isSelectedCountryDE() ? {
                                required: t("Validation.required"),
                                min: { value: 0, message: t("Validation.minValueZero") }
                              }
                              :{}}
                            errors={errors}
                          />
                        </div>
                      </div>}

                </div>

            </>
          )}

          <div className={Style.section}>
            <div className={Style.section__title}>
              {t("ParkingZones.paymentInfo")}
            </div>
            <div className={[Style.rowContainer]}>
              <div
                  className={cn(Style.container, Style["container--marginRight"])}
              >
                <LabelWithHR label={t("EditParkingZoneModal.iban")}/>
                <Controller
                    name="iban"
                    control={control}
                    render={() => (
                        <input
                            type={"text"}
                            className={Style.textStyleInputEditModal}
                            name="iban"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                iban: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.iban}
                        />
                    )}
                />
              </div>
              <div
                  className={cn(Style.container, Style["container--marginLeft"])}
              >
                <LabelWithHR label={t("EditParkingZoneModal.bic")}/>
                <Controller
                    name="bic"
                    control={control}
                    render={() => (
                        <input
                            type={"text"}
                            className={Style.textStyleInputEditModal}
                            name="bic"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                bic: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.bic}
                        />
                    )}
                />
              </div>
            </div>
            <div className={[Style.rowContainer]}>
              <div
                  className={cn(Style.container, Style["container--marginRight"])}
              >
                <LabelWithHR label={t("EditParkingZoneModal.payee")}/>
                <Controller
                    name="payee"
                    control={control}
                    render={() => (
                        <input
                            type={"text"}
                            className={Style.textStyleInputEditModal}
                            name="payee"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                payee: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.payee}
                        />
                    )}
                />
              </div>
              <div
                  className={cn(Style.container, Style["container--marginLeft"])}
              >
                <LabelWithHR
                    label={t("EditParkingZoneModal.financialInstitution")}
                />
                <Controller
                    name="financialInstitution"
                    control={control}
                    render={() => (
                        <input
                            type={"text"}
                            className={Style.textStyleInputEditModal}
                            name="financialInstitution"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                financialInstitution: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.financialInstitution}
                        />
                    )}
                />
              </div>
            </div>

            <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "20px",
                  justifyContent: "space-between",
                }}
            >
              <div style={{zIndex: 3, flex: 1}}>
                <LabelWithHR label={t("ParkingZones.contractDate")}/>
                <Controller
                    name="contractDate"
                    control={control}
                    render={() => (
                        <DatePicker
                            selected={modifyGasStation?.contractDate}
                            popperPlacement="top"
                            dateFormat="dd.MM.yyyy"
                            className={Style.textStyleInputEditModal}
                            locale="de"
                            onChange={(date) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                contractDate: date,
                              });
                            }}
                        />
                    )}
                />
              </div>
              <div style={{flex: 1, marginLeft: "40px"}}>
                <LabelWithHR label={t("ParkingZones.salesArea")}/>
                <Controller
                    name="salesArea"
                    control={control}
                    render={() => (
                        <input
                            type="text"
                            className={Style.textStyleInputEditModal}
                            name="salesArea"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                salesArea: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.salesArea}
                        />
                    )}
                />
              </div>
            </div>

            <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "20px",
                  justifyContent: "space-between",
                }}
            >
              <div style={{zIndex: 3, flex: 1}}>
                <LabelWithHR label={t("GasStations.Others")}/>
                <Controller
                    name="others"
                    control={control}
                    render={() => (
                        <textarea
                            type="text"
                            className={Style.textArea}
                            name="others"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                others: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.others}
                        />
                    )}
                />
              </div>
            </div>
            <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "20px",
                  justifyContent: "space-between",
                }}
            >
              <div style={{zIndex: 3, flex: 1}}>
                <LabelWithHR label={t("GasStations.RepresentedBy")}/>
                <Controller
                    name="representedBy"
                    control={control}
                    render={() => (
                        <input
                            type="text"
                            className={Style.textStyleInputEditModal}
                            name="representedBy"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                representedBy: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.representedBy}
                        />
                    )}
                />
              </div>
              <div style={{flex: 1, marginLeft: "40px"}}>
                <LabelWithHR label={t("GasStations.RelationToProperty")}/>
                <Controller
                    name="relationToProperty"
                    control={control}
                    render={() => (
                        <input
                            type="text"
                            className={Style.textStyleInputEditModal}
                            name="relationToProperty"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                relationToProperty: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.relationToProperty}
                        />
                    )}
                />
              </div>
            </div>

            <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "20px",
                  justifyContent: "space-between",
                }}
            >
              <div style={{zIndex: 3, flex: 1}}>
                <LabelWithHR label={t("GasStations.NotedBy")}/>
                <Controller
                    name="notedBy"
                    control={control}
                    render={() => (
                        <textarea
                            type="text"
                            className={Style.textArea}
                            name="notedBy"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                notedBy: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.notedBy}
                        />
                    )}
                />
              </div>
            </div>

            <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "20px",
                  justifyContent: "space-between",
                }}
            >
              <div style={{zIndex: 3, flex: 1}}>
                <LabelWithHR label={t("GasStations.InjuredPerson")}/>
                <Controller
                    name="injuredPerson"
                    control={control}
                    render={() => (
                        <textarea
                            type="text"
                            className={Style.textArea}
                            name="injuredPerson"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                injuredPerson: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.injuredPerson}
                        />
                    )}
                />
              </div>
            </div>

            <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "20px",
                  justifyContent: "space-between",
                }}
            >
              <div style={{zIndex: 3, flex: 1}}>
                <LabelWithHR label={t("GasStations.AdditionalInfo")}/>
                <Controller
                    name="additionalInfo"
                    control={control}
                    render={() => (
                        <textarea
                            type="text"
                            className={Style.textArea}
                            name="additionalInfo"
                            onChange={(e) => {
                              setModifyGasStation({
                                ...modifyGasStation,
                                additionalInfo: e.target.value,
                              });
                            }}
                            defaultValue={modifyGasStation?.additionalInfo}
                        />
                    )}
                />
              </div>
            </div>
          </div>

          <div className={Style.section}>
            <div className={Style.section__title}>
              {t("ParkingZones.documents")}
            </div>
            <div className={Style.container}>
              <>
                <label htmlFor="file-upload" className={Style.fileUpload}>
                  {t("GasStations.PowerOfAttorney")}
                </label>
                {powerOfAttorneyName !== "" && (
                    <label>
                      {powerOfAttorneyName === "" ? null : (
                          <div>
                            {showDocumentsNames(
                                powerOfAttorney,
                                setPowerOfAttorney,
                                powerOfAttorneyName,
                                setPowerOfAttorneyName
                            )}
                          </div>
                      )}
                    </label>
                )}

                <input
                    id="file-upload"
                    type="file"
                    accept="image/jpg, image/png, image/jpeg"
                    className="powerOfAttorney"
                    onChange={(e) => {
                      documentUpload(
                          e,
                          powerOfAttorney,
                          setPowerOfAttorney,
                          powerOfAttorneyName,
                          setPowerOfAttorneyName,
                          true
                      );
                    }}
                    multiple={false}
                />
                {showPoaIgnoredWarning && (
                    <div className={Style.docsWarning}>
                      {selectedClient && !selectedClient.powerOfAttorneyName
                          ? t("GasStations.clientDocsNoClientPoaWarning")
                          : t("GasStations.clientDocsPoaIgnoredWarning")}
                    </div>
                )}
                <label htmlFor="documentation" className={Style.fileUpload}>
                  {t("GasStations.GSDocumentation")}
                </label>
                {documentationName !== "" && (
                    <label>
                      {documentationName === "" ? null : (
                          <div>
                            {showDocumentsNames(
                                documentation,
                                setDocumentation,
                                documentationName,
                                setDocumentationName
                            )}
                          </div>
                      )}
                    </label>
                )}
                <input
                    id="documentation"
                    type="file"
                    accept=".pdf, .docx"
                    className="documentation"
                    multiple
                    onChange={(e) => {
                      documentUpload(
                          e,
                          documentation,
                          setDocumentation,
                          documentationName,
                          setDocumentationName,
                          false
                      );
                    }}
                />
              </>
            </div>
          </div>

          <div className={Style.section}>


            {viewersIds && renderEditViewers(viewersIds)}
            <button
                type="button"
                className={
                  viewersIds?.includes("0")
                      ? Style.addManagerButtonDisabled
                      :
                      Style.addManagerButton
                }
                onClick={() => {
                  setViewersIds([...viewersIds, "0"]);
                  setViewersComboBoxNames([
                    ...viewersComboBoxNames,
                    viewerCounter + 1,
                  ]);
                  setViewerCounter(viewerCounter + 1);
                }}
                disabled={viewersIds && viewersIds?.includes("0")}
            >
              {"+" + t("Viewer.addViewer")}
            </button>
            <div className={cn(Style.section__title, Style.paddingTop)}>
              {t("ParkingZones.chooseAdmin")}
            </div>
            {isLoggedUserSysadmin ? (
                <Controller
                    name="adminKeycloakId"
                    control={control}
                    render={() => (
                        <Autocomplete
                            size="small"
                            id={"keycloakAdminId"}
                            onChange={(e, value) => {
                              if (value) {
                                setGasStationAdmin(value.id);
                              }
                            }}
                            disableClearable
                            value={admins.find(x => x.id === modifyGasStation?.adminKeycloakId) || null}
                            renderInput={(params) => <TextField {...params} placeholder={"auswählen"}/>}
                            options={admins}
                            getOptionSelected={(option, value) => option.id === value.id}
                            getOptionLabel={(x) => `${x.firstName} ${x.lastName} | ${x.emailAddress} ${x.companyName ? "| " + x.companyName : ""}`}
                        />
                    )}
                />
            ) : (
                <div className={Style.text}>
                  {loggedUser?.firstName + " " + loggedUser?.lastName}
                </div>
            )}

            {managersIds && renderEditManagers(managersIds)}
            <button
                type="button"
                className={
                  managersIds?.includes("0")
                      ? Style.addManagerButtonDisabled
                      : Style.addManagerButton
                }
                onClick={() => {
                  setManagersIds([...managersIds, "0"]);
                  setManagersComboBoxNames([
                    ...managersComboBoxNames,
                    counter + 1,
                  ]);
                  setCounter(counter + 1);
                }}
                disabled={managersIds && managersIds?.includes("0")}
            >
              {"+ Neue Manager"}
            </button>

            {beppolicemansIds && renderEditBeppolicemans(beppolicemansIds)}

            <div className={Style.buttonContainer}>
              <Button
                  style={{
                    width: "25%",
                  }}
                  buttonStyle={{
                    width: "100%",
                  }}
                  disabled={isSubmitDisabled}
                  text={t("Save")}
              />
            </div>
          </div>
        </div>

      </form>
    </Modal>
  );
};
export default EditGasStationModal;
